import type { ReactNode } from 'react';

/**
 * Les deux briques de mise en page partagees par les sections de Parametres.
 *
 * Une carte, et une ligne « libelle a gauche, controle a droite ». Rien
 * d'autre : le libelle suffit, la section ouverte donne deja le contexte.
 * Les titres de section et les textes d'aide ont ete retires le 2026-09-30,
 * ils repetaient l'entree de menu qui venait d'etre cliquee.
 *
 * W4 : le titre de la section est revenu, une seule fois, en tete de page
 * (SettingsScreen). Une section longue se decoupe en groupes nommes
 * (SettingsGroup), et une ligne peut porter une phrase d'aide quand le
 * libelle seul ne dit pas ce que le reglage fait.
 */

export function SettingsGroup({ title, children, id }: { title: ReactNode; children: ReactNode; id?: string }) {
  return (
    <section className="space-y-3" id={id}>
      <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{title}</h3>
      {children}
    </section>
  );
}

export function SettingsCard({ children }: { children: ReactNode }) {
  return (
    <div className="bg-card border border-border rounded-xl shadow-sm overflow-hidden">
      {children}
    </div>
  );
}

export function SettingsRow({
  label,
  hint,
  last,
  children,
}: {
  label: ReactNode;
  hint?: ReactNode;
  last?: boolean;
  children: ReactNode;
}) {
  return (
    // QA-W4-5: stacked on a phone (label, then the control); side by side
    // from sm up. In a row at 390 px the shrink-0 control left the label one
    // word per line.
    <div data-testid="settings-row" className={`px-5 py-4 flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4 ${!last ? 'border-b border-border' : ''}`}>
      <div className="min-w-0 sm:flex-1">
        <p className="text-sm font-medium text-foreground">{label}</p>
        {hint ? <p className="text-xs text-muted-foreground mt-0.5">{hint}</p> : null}
      </div>
      <div className="max-w-full sm:shrink-0">{children}</div>
    </div>
  );
}
